import './Auth.style.scss';
import './Register.scss';

import { ArrowForward, Google } from '@mui/icons-material'; //VisibilityOff
import { Button } from '@mui/material';
import { useGoogleLogin } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import {useTranslation } from 'react-i18next';
// import "./Register.style.scss"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import axios from '../../Api/axios';
import { DELAY, ROLES } from '../../config';
import Logo from '../../data/Logo';
import { ClientSVG, DrawLine, ESNSVG, ExpertSVG, RegisterSvgDraw } from '../../data/SVGs';
import useAuthSetState from '../../hooks/useAuthSetState';
import useFormValidation, { champRequisString, isErrorObjectClean } from '../../hooks/useFormValidation';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { requiredColorCode } from '../../Styles/componentStyles';
import { getCodeFromRole } from '../../Utils/utils';
import { isValidEmail, validatePassword } from '../../Utils/validationUtils';
import {buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import NavbarHome from '../shared/Navbar/NavbarHome';
import { TextFieldComponent } from '../shared/ReusableSmallComponents';
import SelectRadioBtn from '../shared/SelectGender';
import AutoTextChanger from './AutoTextChanger';
import PasswordInput from './PasswordInput';
export function radiof() {
    var myRadio = document.querySelectorAll('input[name="radio"]'); // get radio
    var myNotes = document.querySelectorAll('.BoxRegister'); // get notes
    if (myRadio[0].checked === true) { // if the first radio checked
        myNotes[0].style.borderColor = 'rgba(33, 77, 206, 1)'; // show first note
        // myNotes[1].style.display = 'none'; // hide the second
    }
    else {
        myNotes[0].style.borderColor = '#9D9E9F';
    }
    if (myRadio[1].checked === true) { // if not do the apposite
        myNotes[1].style.borderColor = 'rgba(33, 77, 206, 1)';
    }
    else {
        myNotes[1].style.borderColor = '#9D9E9F';
    }
    if (myRadio[2].checked === true) { // if not do the apposite
        myNotes[2].style.borderColor = 'rgba(33, 77, 206, 1)';
    }
    else {
        myNotes[2].style.borderColor = '#9D9E9F';
    }
}
function getRadioDivStylingBySelectedRole({ role, userRole , isRequired}) {
    if (isRequired) {
        return { borderColor: requiredColorCode };
    }
    if (userRole == role) {
        return { borderColor: 'rgba(33, 77, 206, 1)' };
    }
    else return { borderColor: '#9D9E9F' };
}

function RegisterStepOne() {
    const { setShowErrors, showErrors, errors, setErrors } = useUtilities();
    const login = useGoogleLogin({ onSuccess: handleGoogleLoginSuccess });
    const { setAuthState, RedirectRoleAndFromBased } = useAuthSetState();
    let navigate = useNavigate();
    const {device}=useWindowSize();
    const divRef = useRef(null);
    const [width, setWidth] = useState(0);

    const [genre, setGenre] = useState(''); //mr
    const [email, setEmail] = useState();
    const [nom, setNom] = useState();
    const { i18n } = useTranslation();
    const [prenom, setPrenom] = useState();
    const [userRole, setUserRole] = useState('');//? why it was true ??
    const [password, setPassword] = useState('');
    const [repeatedPassword, setRepeatedPassword] = useState('');
    const [passwordError, setPasswordError] = useState();
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [isRepeatedPasswordShown, setisRepeatedPasswordShown] = useState(false);
    // * Email validation
    const [isDuplicatedOrInvalid, setIsDuplicatedOrInvalid] = useState(false);
    // const [emailValid, setEmailValid] = useState(false);
    const [signupErrorEmail, setSignupErrorEmail] = useState(champRequisString);
    usePersistedLanguage();
    const [isValid, setIsValid] = useFormValidation([
        { name: 'userRole', value: userRole },
        { name: 'genre', value: genre },
        { name: 'prenom', value: prenom },
        { name: 'nom', value: nom },
        { name: 'email', value: email },
        { name: 'password', value: password },
        { name: 'repeatedPassword', value: repeatedPassword },
    ]);

    //useEffect(() => {
    //    if (divRef.current) {
    //        const rect = divRef.current.getBoundingClientRect();
    //        setWidth(rect.width);
    //    }
    //}, [divRef.current]);

    useEffect(() => {
        const updateWidth = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setWidth(rect.width);
            }
        };

        // Call the function initially to set the initial width
        updateWidth();

        // Attach the event listener to update the width when the window is resized
        window.addEventListener('resize', updateWidth);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [divRef]);

    // ! TODO : to add for focus
    // TODO : const userRef = useRef();
    //focus on the first input when the component load
    //const errRef = useRef();//focus on error
    useEffect(() => {
        // ! in odrer to not have a lot of requests {dos}
        if (!email) return;
        if (isDuplicatedOrInvalid) {
            setTimeout(() => {
                verifyDuplicated(email);
            }, DELAY);
        }
        else {
            setTimeout(() => {
                verifyDuplicated(email);
            }, DELAY);
        }
    }, [email]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    useEffect(() => {
        validatePassword(password, repeatedPassword, setPasswordError, setIsPasswordValid);
    }, [password, repeatedPassword]);

    const togglePassword = () => {
        setIsPasswordShown(!isPasswordShown);
    };
    const toggleRepeatedPassword = () => {
        setisRepeatedPasswordShown(!isRepeatedPasswordShown);
    };
    const createUser = async () => {
        //if (!CGU_checked) { return; }
        // TODO: change number roles with CONSTANT like BAckend
        // console.log('222',genre);
        const role = getCodeFromRole(userRole);
        axios.post('auth/registerUser',
            { email, password, nom, prenom, genre, role })
            .then(function (response) {
                //! setSavedResponse(response); the AT must nbe passed here to next Page
                console.log('recieved token 1st step create account = \n' + response.data.accessToken);
                // let responseData = JSON.stringify(response);
                navigate('/almostDone'
                    , {
                        state:
                            { savedResponse: response.data }
                    }
                );
            })
            .catch(function (error) {
                // setSignupError(error.response.data?.error)
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.response.data?.error,
                });
                console.log(error.response.status); // 401
                console.log('error== ' + error.response.data?.error);
            });
    };

    const verifyDuplicated = async (email) => {
        console.log('filled Email \t' + email + ' ++ ' + email);
        axios.post('auth/verifyDuplicated', { email })
            .then(function (response) {
                console.log('email is NOT Duplicated', response);
                setIsDuplicatedOrInvalid(false);
                // setIsValid(true);
                // setSignupErrorEmail('');
                validateEmail(email);
            })
            .catch(function (error) {
                // setIsValid(false);
                setSignupErrorEmail(error.response.data?.error);
                setIsDuplicatedOrInvalid(true);
                console.log(error.response.data?.error, error.response.status);
            });
    };

    // ! not for prod  because he could do next even email is not unique !!
    //TODO , fix it [try enable desiable || clickable non clickable btn "NEXT"]

    function validateEmail(email) {
        if (!isValidEmail(email)) {
            setSignupErrorEmail('E-mail non valide');
            // setIsValid(false);
        }
        else {
            setSignupErrorEmail('');
            // setIsValid(true);
        }
    }

    // pattern: {
    //         value: /^[a-zA-Z]+$/,
    //         message: 'First name should contain only characters.'
    //     }

    function handleGoogleLoginSuccess(tokenResponse) {
        const googleAccessToken = tokenResponse.access_token;
        console.log(googleAccessToken);
        fetch(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${googleAccessToken}`, {
            method: 'get',
        })
            .then(resp => resp.json())
            .then(googleOAuth2Data => {
                // setUrl(data.url);
                console.log(googleOAuth2Data);
                axios.post('auth/registerUser',
                    { role: ROLES.Expert ,googleAccessToken, googleOAuth2Data })
                    .then(function (response) {
                        console.log('recieved token 1st step create account = \n' + response.data);
                        // 202 = Accepted == Normal Login = AT & RT recieved
                        setAuthState({ responseData: response.data });
                        RedirectRoleAndFromBased({ role: response?.data?.user?.role });
                    })
                    .catch(function (error) {
                        // setSignupError(error.response.data?.error)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.response.data?.error,
                        });
                        console.log(error.response.status); // 401
                        console.log('error== ' + error.response.data?.error);
                    });
            })
            .catch(err => console.log(err));
    }

    return (
        <React.Fragment>
            <form className='HomePageInscription'>
                {device!='desktop'&&
                <NavbarHome />
                }
                {device=='desktop'&&
                <div className='FirstRectangle'>
                    <div className='LogoTitle'>
                        <div className='frame0RegisterStepOne'>
                            <Logo
                                width='198px'
                                height='54px'
                            />
                        </div>
                        <div className='frame1RegisterStepOne'>
                            <h3 className='TitleInscrire'> {i18n.t('Joindre notre communauté des ')}
                                <h3
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        fontSize: '48px',
                                        display: 'inline',
                                        lineHeight: '56px',
                                        color: 'rgba(92, 200, 137, 1)'
                                    }}
                                > <AutoTextChanger/>
                                </h3>
                            </h3>
                        </div>
                    </div>
                    <div className='DrawIconeStyle'>
                        <RegisterSvgDraw />
                    </div>
                </div>
                }
                <div  className='rect123434'>
                    {device=='desktop'&&
                    <div className='BtnSinscrire'>
                        <p style={{margin:0}}>{i18n.t('Déjà enregistré?')}  &nbsp; &nbsp;</p>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/login')}
                            style={{
                                ...buttonStyles(false),
                                ...{height:'36px'}
                            }}
                            startIcon={<ArrowForward />}
                        >
                            {i18n.t('Se connecter')}
                        </Button>
                    </div>
                    }
                    <div className='GrandBox'>
                        <div className='Etape'>
                            <div className='E12'>
                                <p className='etape12'>{i18n.t('Etape 1/2')}</p>
                                <div className='E12F2'>
                                    <div className='frame2RegisterStepOne'>
                                    </div>
                                    <div className='frame3RegisterStepOne'>
                                    </div>
                                    <div className='frame4RegisterStepOne'>
                                    </div>
                                </div>
                            </div>
                            <h1 className='creercompte'>{i18n.t('Créer un compte')}</h1>
                        </div>
                        <div className='ElementBox2'>
                            <div className='element1'>
                                <h5 className='Vousetes'>
                                    {i18n.t('Vous êtes?')}
                                </h5>
                                <div
                                    className='GridBox2'
                                    // style={!userRole && showErrors ? {border: '3px solid red'} : null}
                                >
                                    <div
                                        className='BoxRegister'
                                        onClick={() => { setUserRole('expert'); }}
                                        style={getRadioDivStylingBySelectedRole({ role: 'expert', userRole: userRole , isRequired: (!userRole && showErrors) })}
                                    >
                                        {device=='desktop' &&
                                        <input
                                            type="radio"
                                            name="radio"
                                            id="expert"
                                            checked={userRole == 'expert'}
                                            // onChange={e => {setUserRole(e.target.value);radiof();}}
                                            // value="expert"
                                            required
                                        />}
                                        <ExpertSVG height={'100%'}/>
                                        <h6 className='texBox TitlesTypesUsers'> {device=='desktop' ? i18n.t('Expert') : i18n.t('Je suis Expert')}</h6>
                                        {device!='desktop' &&
                                        <input
                                            type="radio"
                                            name="radio"
                                            id="expert"
                                            checked={userRole == 'expert'}
                                            // onChange={e => {setUserRole(e.target.value);radiof();}}
                                            // value="expert"
                                            required
                                        />}
                                    </div>
                                    <div
                                        className='BoxRegister'
                                        onClick={() => { setUserRole('client'); radiof(); }}
                                        style={getRadioDivStylingBySelectedRole({ role: 'client', userRole: userRole , isRequired: (!userRole && showErrors) })}
                                    >
                                        {device=='desktop'&&
                                        <input
                                            type="radio"
                                            name="radio"
                                            checked={userRole == 'client'}
                                            // value="client"
                                            // onChange={e => {setUserRole(e.target.value);radiof();}}
                                            id="client"
                                        />
                                        }
                                        <ClientSVG height={'100%'}/>
                                        <h6 className='texBox TitlesTypesUsers'> {device=='desktop' ? i18n.t('Client') : i18n.t('Je suis Client')}</h6>
                                        {device!='desktop'&&
                                        <input
                                            type="radio"
                                            name="radio"
                                            checked={userRole == 'client'}
                                            // value="client"
                                            // onChange={e => {setUserRole(e.target.value);radiof();}}
                                            id="client"
                                        />
                                        }
                                    </div>
                                    <div
                                        className='BoxRegister'
                                        //masquer pour v1
                                        onClick={() => { setUserRole('esn'); radiof(); }}
                                        style={getRadioDivStylingBySelectedRole({ role: 'esn', userRole: userRole , isRequired: (!userRole && showErrors) })}
                                    >
                                        {device=='desktop'&&
                                            <input
                                                type="radio"
                                                checked={userRole == 'esn'}
                                                name="radio"
                                                // value="esn"
                                                //style={{pointerEvents: 'none', /* Disable mouse interactions */}}
                                                //masquer pour v1
                                                //onChange={e => { setUserRole(e.target.value); radiof(); }}
                                                id="esn"
                                            />
                                        }
                                        <ESNSVG height={'100%'}/>
                                        <h6 className='texBox TitlesTypesUsers'>{device=='desktop' ? i18n.t('ESN') : i18n.t('Je suis ESN')}</h6>
                                        {device!='desktop'&&
                                            <input
                                                type="radio"
                                                name="radio"
                                                checked={userRole == 'esn'}
                                                // value="esn"
                                                //masquer pour v1
                                                //onChange={e => { setUserRole(e.target.value); radiof(); }}
                                                id="esn"
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='Element2'>
                                {(!userRole && showErrors) ? <p style={{color: requiredColorCode}}> {i18n.t('Champ requis')}</p> : null}
                                <h5 className='Titre2Box2'>
                                    {i18n.t('Dites-nous plus sur vous')}
                                </h5>
                                {/* <div className='TitreR'> */}
                                {/*<p className='TitreStyle'>Titre</p>     */}
                                <SelectRadioBtn
                                    value={genre}
                                    setValue={setGenre}
                                    name="genre"
                                    options={[
                                        { label: 'Madame', optionValue: 'mme' },
                                        { label: 'Monsieur', optionValue: 'mr' }
                                    ]}
                                    // setCheckUpdateValue={setCheckUpdateValue}
                                    // setCheckUpdateValue={setCheckUpdateValue}
                                />
                                {/* </div> */}
                                <div className='FormBox2'>
                                    <div className='frame5RegisterStepOne'>
                                        <div className='frame7RegisterStepOne'>
                                            <TextFieldComponent
                                                //id="outlined-multiline-flexible"
                                                //style = {{width: '286.5px'}}
                                                label={i18n.t('Nom*')}
                                                value={nom}
                                                name='nom'
                                                // multiline
                                                // maxRows={4}
                                                style={{width: '100%'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius: '8px' },
                                                }}
                                                variant="outlined"
                                                className='test'
                                                onChange={e => setNom(e.target.value)}
                                            />
                                        </div>
                                        <div className='frame7RegisterStepOne'>
                                            <TextFieldComponent
                                                label={i18n.t('Prénom')}
                                                value={prenom}
                                                name='prenom'
                                                //style = {{width: '286.5px'}}
                                                style={{width: '100%'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius: '8px' },
                                                }}
                                                //id="outlined-textarea"
                                                // multiline
                                                variant="outlined"
                                                onChange={e => setPrenom(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className='frame5RegisterStepOne'>
                                        <TextFieldComponent
                                            label={i18n.t('Email*')}
                                            value={email}
                                            name='email'
                                            id="email"
                                            // multiline
                                            // maxRows={4}
                                            style={{width: '100%'}}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px' },
                                            }}
                                            variant="outlined"
                                            autoComplete='false'
                                            //style = {{width: ''}}
                                            onChange={e => {
                                                setEmail(e.target.value);
                                                validateEmail(e.target.value);
                                            }}
                                            // error={signupErrorEmail == '' ? false : true}
                                            // helperText={signupErrorEmail}
                                        />
                                    </div>
                                    <div className='frame5RegisterStepOne'>
                                        <div className='frame7RegisterStepOne'>
                                            <PasswordInput
                                                label={i18n.t('Mot de passe*')}
                                                name='password'
                                                variant="outlined"
                                                style={{width: '100%'}}
                                                sx={{ '& > :not(style)': {borderRadius: '8px' }, }}
                                                isPasswordShown={isPasswordShown}
                                                togglePassword={togglePassword}
                                                password={password}
                                                setPassword={setPassword}
                                                isPasswordValid={isPasswordValid}
                                                passwordError={passwordError}
                                            />
                                        </div>
                                        <div className='frame7RegisterStepOne'>
                                            <PasswordInput
                                                name='repeatedPassword'
                                                label={i18n.t('Confirmer votre mot de passe*')}
                                                isConfirmationPassword={true}
                                                style={{width: '100%'}}
                                                sx={{
                                                    '& > :not(style)': {borderRadius: '8px' },
                                                }}
                                                isPasswordShown={isRepeatedPasswordShown}
                                                togglePassword={toggleRepeatedPassword}
                                                password={repeatedPassword}
                                                setPassword={setRepeatedPassword}
                                                isPasswordValid={isPasswordValid}
                                                passwordError={passwordError}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <p className='Gru'>
                                    {i18n.t('En cliquant sur "suivant", j\'accepte les ')}<a href="termsOfService"> <span style={{ color: 'rgba(64, 144, 247, 1)' }}> {i18n.t('conditions générales ')}</span></a>
                                    <p
                                        style={{
                                            color: 'rgba(64, 144, 247, 1)',
                                            fontFamily: 'Lato',
                                            fontStyle: 'normal',
                                            fontWeight: '400',
                                            fontSize: '14px',
                                            display: 'inline',
                                            lineHeight: '16px',
                                        }}
                                    >
                                    </p> {i18n.t('d\'utilisation de High Tech Hires, y compris l\'accord d\'utilisation et la ')}

                                    <a href="privacyPolicy"><span style={{ color: 'rgba(64, 144, 247, 1)' }}> {i18n.t('politique de confidentialité.')}</span></a>
                                </p>
                                <div className='BtnNext'>
                                    {
                                        userRole === 'expert' &&
                                        <>
                                            <div className='frame7RegisterStepOne'>
                                                <Button
                                                    style={{
                                                        ...buttonStyles(false),
                                                        ...{width: '100%',color: '#272D3C' }
                                                    }}
                                                    variant='outlined'
                                                    onClick={() => login()}
                                                    startIcon={<Google style={{ color: 'red' }} />}
                                                >
                                                    {i18n.t('Connectez-vous avec Google')}
                                                </Button>
                                            </div>

                                            <div className='frame7RegisterStepOne'>
                                                <Button
                                                    //TODO : make this suivant One button, treat the styling for both conditions in one component
                                                    variant="contained"
                                                    type="submit"
                                                    // disabled when !emailIsDuplicatedOrInvalid {isDplc=false}|| CGU_checked = false || emailValid = false
                                                    // disabled={!isPasswordValid || isDuplicatedOrInvalid}
                                                    style={{
                                                        ...buttonStylesBlue(!isPasswordValid), ...{
                                                            //marginBottom: '20px',
                                                            width: '100%',
                                                        }
                                                    }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        console.log({isValid , isDuplicatedOrInvalid ,isPasswordValid, isObjectClean: isErrorObjectClean({ ...errors, ...{ email: signupErrorEmail } })} , { ...errors, ...{ email: signupErrorEmail } });
                                                        if (signupErrorEmail != '' || !isValid || isDuplicatedOrInvalid || !isPasswordValid || !isErrorObjectClean({ ...errors, ...{ email: signupErrorEmail } })) { //|| !isValid || isDuplicatedOrInvalid || !isPasswordValid
                                                            setShowErrors(true);
                                                            setErrors({ ...errors, ...{ email: signupErrorEmail } });
                                                            // setIsValid(false);
                                                        }
                                                        else {
                                                            createUser(e);
                                                            setShowErrors(false);
                                                            setErrors({});
                                                        }
                                                    }}
                                                    startIcon={<ArrowForward />}
                                                >
                                                    {i18n.t('Suivant')}
                                                </Button>
                                            </div>
                                        </>
                                    }
                                    {
                                        userRole != 'expert' &&
                                        <>
                                            <Button
                                                variant="contained"
                                                type="submit"
                                                // disabled={!isPasswordValid || isDuplicatedOrInvalid}
                                                style={{
                                                    ...buttonStylesBlue(!isPasswordValid), ...{
                                                        //marginBottom: '20px',
                                                        width: '100%',
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    console.log({isValid ,signupErrorEmail, isDuplicatedOrInvalid ,isPasswordValid, isObjectClean: isErrorObjectClean({ ...errors, ...{ email: signupErrorEmail } })} , { ...errors, ...{ email: signupErrorEmail } });
                                                    if (signupErrorEmail != '' || !isValid || isDuplicatedOrInvalid || !isPasswordValid
                                                    || !isErrorObjectClean({ ...errors, ...{ email: signupErrorEmail } })) { //|| !isValid || isDuplicatedOrInvalid || !isPasswordValid
                                                        setShowErrors(true);
                                                        setErrors({ ...errors, ...{ email: signupErrorEmail } });
                                                        setIsValid(false);
                                                    }
                                                    else {
                                                        createUser();
                                                        setShowErrors(false);
                                                        setErrors({});
                                                    }
                                                }}
                                                startIcon={<ArrowForward />}
                                            >
                                                {i18n.t('Suivant')}
                                            </Button>
                                        </>
                                    }
                                </div>
                                {device!='desktop' &&
                                <>
                                    <div className='rect127434' >
                                        <div
                                            style={{width:'47%'}}
                                            ref={divRef}
                                        >
                                            <DrawLine width={width} />
                                        </div>
                                        <span style={{width:'6%',textAlign:'center'}}>{i18n.t('Ou')}</span>
                                        <div style={{width:'47%'}}>
                                            <DrawLine width={width}/>
                                        </div>
                                    </div>
                                    <div className='BtnSinscrire'>
                                        <p style={{margin:0}}>{i18n.t('Déjà enregistré?')}  &nbsp; &nbsp;</p>
                                        <Button
                                            variant="outlined"
                                            onClick={() => navigate('/login')}
                                            style={{
                                                ...buttonStyles(false),
                                                ...{height:'36px'}
                                            }}
                                            startIcon={<ArrowForward />}
                                        >
                                            {i18n.t('Se connecter')}
                                        </Button>
                                    </div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
}

export default RegisterStepOne;